import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ProductService } from 'src/app/services/product-service/product.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { Product } from '../models/type/product.model';
import { Shop } from '../models/type/shop.model';

@Component({
  selector: 'app-information',
  templateUrl: './information.page.html',
  styleUrls: ['./information.page.scss'],
})
export class InformationPage implements OnInit {
  // shop: Shop;
  shop;
  // product: Product;
  product;
  id: number;
  constructor(
    private productService: ProductService,
    private activatedRoute: ActivatedRoute,
    private shopService: ShopServiceService,
    private router: Router
  ) {
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    // this.product = this.productService.getProduct(this.id);
    this.productService
      .getProduct(this.id)
      .pipe(take(1))
      .subscribe((res) => {
        this.product = res.data();
      });
    // this.shop = this.shopService.getShop(this.id);
    this.shopService
      .getShop(this.id)
      .pipe(take(1))
      .subscribe((res) => {
        this.shop = res.data();
      });
  }

  goToShop(id: number) {
    this.router.navigate(['home/products', id]);
  }
}
